<template>
  <so-quit-button class="pill" :disabled="disabled" @click="quit" />
</template>

<script>
import { mapActions } from 'vuex'
import SoQuitButton from '@/components/common/SoQuitButton'

export default {
  name: 'SoQuitButtonContainer',
  components: {
    SoQuitButton,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    noShadow: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  methods: {
    ...mapActions({
      deauth: 'auth/deauth',
    }),
    async quit() {
      await this.deauth()

      if (this.isApp) {
        window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/home`
      } else {
        if (this.$route.path === '/') return
        this.$router.push({ path: '/' })
      }
    },
  },
}
</script>
